import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedAttempts() {
  const attempts = ['Las dietas de internet usan ingredientes caros y exóticos que no pillas ni en el Jumbo más grande.', 'Los planes de "contar calorías" no sirven si lo que comes está irritando tus hormonas y tu intestino.', 'El enfoque "Fit" tradicional requiere horas de cocina que una mujer profesional y jefa de hogar simplemente no tiene.'];
  return <section className="py-12 md:py-14 bg-brand-cream" data-id="element-49">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-navy mb-4" data-id="element-52">
            Por qué lo que has intentado{' '}
            <span className="text-red-600/80 line-through decoration-2" data-id="element-53">
              no funcionó
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-54">
          {attempts.map((attempt, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-navy/5 relative overflow-hidden" data-id="element-55">
              <div className="absolute top-0 left-0 w-full h-1 bg-red-500/20" data-id="element-56"></div>
              <XCircle className="w-10 h-10 text-red-500/60 mb-6" data-id="element-57" />
              <p className="text-gray-700 leading-relaxed font-medium" data-id="element-58">
                {attempt}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}